import { Component,Input, Output, EventEmitter } from '@angular/core';
import { Options } from 'ng5-slider';
import { Percentages } from './percentages.model';

@Component({
  selector: 'app-triple-percentage-slider',
  templateUrl: './triple-percentage-slider.component.html',
  styleUrls: ['./triple-percentage-slider.component.css']
})


export class TriplePercentageSliderComponent  {
  @Output() percentagesChanged: EventEmitter<object> =   new EventEmitter();

  value: number = 0;
  highValue: number = 100;

  percentages: Percentages = new Percentages(0, 0, 100);
  
  prevSecondPerc = this.percentages.second;

  updateInput() {
    this.percentages.first = this.value;
    this.percentages.second = this.highValue - this.value;
    this.percentages.third = 100 - this.highValue;
    this.prevSecondPerc = this.percentages.second;
    this.percentagesChanged.emit(this.percentages);
  }

  updateMin(inputValue: number) {
    this.value = inputValue;
    this.percentages.first = this.value;
    this.percentages.second = this.highValue - this.percentages.first;
    if (this.value > this.highValue) {
        this.highValue += (this.value - this.highValue);
        this.percentages.second = 0;    
        this.percentages.third = (100 - this.highValue) > 0 ? (100 - this.highValue) : 0;
    }
    this.prevSecondPerc = this.percentages.second;
    this.percentagesChanged.emit(this.percentages);
  }

  updateMid(inputValue: number) {  
    this.percentages.second = inputValue;
    if (this.percentages.second < this.prevSecondPerc) {
      this.highValue -= (this.prevSecondPerc - this.percentages.second);
      this.percentages.third = 100 - this.highValue;
      this.prevSecondPerc = this.percentages.second;
    } else {   
        this.highValue += (this.percentages.second - this.prevSecondPerc);
        if (this.highValue >= 100 && this.value > 0) {
          this.value -= (this.highValue - 100);       
          if (this.highValue > 100) {
            this.highValue = 100;
          }      
        }
        this.percentages.first = this.value;
        this.percentages.third = 100 - this.highValue; 
        this.prevSecondPerc = this.percentages.second;
    }       
    this.percentagesChanged.emit(this.percentages);
  }

  updateMax(inputValue: number) {
    this.percentages.third = inputValue;
    this.highValue = 100 - inputValue;
    this.percentages.second = 100 - (this.value + (100 - this.highValue));
    if (this.value > this.highValue) {
        this.value -= (this.value - this.highValue);
        this.percentages.second = 0;
        this.percentages.first = this.value;
    }
    this.prevSecondPerc = this.percentages.second;
    this.percentagesChanged.emit(this.percentages);
  }
  
  options: Options = {
    floor: 0,
    ceil: 100
  };
}


// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-3/triple-percentage-slider/triple-percentage-slider.component.ts